module.exports = __webpack_public_path__ + "88a07f4898384dc05bd88eb9ea28aaf8.png";